<template>
  <div class="new-order-wrapper">
    <h3 class="section-title-centered">{{ title }}</h3>
      <form @submit.prevent="onSubmit">
        <div class="form-row">
          <div class="col-6">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Username</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="obj.username"
                    v-validate="'required'"
                    name="username"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('username')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('username')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('username') }}
                  </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Password</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="obj.password"
                    class="form-control"
                  />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>ID</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    v-model="obj.ref"
                    v-validate="{
                      required: true,
                      uniqueRef: obj
                    }"
                    name="ref"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('ref')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('ref')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('ref') }}
                  </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Staff group</label>
                <div class="col-sm-7 pt-3">
                  <div
                    class="form-control-custom"
                    :class="{
                      'is-invalid': submitted && errors.has('userGroup')
                    }"
                  >
                    <div
                      v-for="userGroup in userGroups"
                      class="pb-1"
                    >
                      <input
                        type="radio"
                        class="custom-radio"
                        name="userGroup"
                        v-validate="'required'"
                        v-model="obj.userGroup"
                        :value="userGroup.id"
                      />&nbsp; {{ userGroup.name }}
                    </div>
                  </div>
                  <div
                    v-if="submitted && errors.has('userGroup')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('userGroup') }}
                  </div>
                </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>First name</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    name="firstName"
                    v-model="obj.firstName"
                    v-validate="'required'"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('firstName')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('firstName')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('firstName') }}
                  </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Last name</label>
                <div class="col-sm-7">
                  <input
                    type="text"
                    name="lastName"
                    v-model="obj.lastName"
                    v-validate="'required'"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && errors.has('lastName')
                    }"
                  />
                  <div
                    v-if="submitted && errors.has('lastName')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('lastName') }}
                  </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Can Login</label>
                <div class="col-sm-7 pt-3">
                  <input
                    type="checkbox"
                    name="authPermitted"
                    v-model="obj.authPermitted"
                  />&nbsp;
                  <translate class="staff-form-can-login">POS</translate>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Permission</label>
                <div class="col-sm-7 pt-3">
                  <div
                    class="form-control-custom"
                    :class="{
                      'is-invalid': submitted && errors.has('subRoles')
                    }"
                  >
                    <div
                      v-for="role in roles"
                      class="pb-1 text-nowrap"
                    >
                      <input
                        type="checkbox"
                        name="subRoles"
                        v-validate="'required'"
                        v-model="obj.subRoles"
                        :value="role.id"
                      />&nbsp; {{ role.name }}
                    </div>
                  </div>
                  <div
                    v-if="submitted && errors.has('subRoles')"
                    class="invalid-feedback"
                  >
                    {{ errors.first('subRoles') }}
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="form-footer py-lg-3 text-center">
          <button type="submit" class="btn btn-primary px-5" v-translate>Submit</button>
        </div>
      </form>
  </div>
</template>

<script>
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
import StaffService from "@/services/StaffService";

export default {
  name: 'FormStaff',
  props: ['title'],
  data() {
    return {
        obj: {
          subRoles: [],
          userGroup: null,
          location: null,
          subLocations: []
        },
        submitted: false,
    }
  },
  computed: {
    defaultUserGroup() {
      return this
              .getArray('userGroups')
              .find(userGroup => {
                return userGroup.name == 'Service'
              });
    },
    userGroups() {
      return this
              .getArray('userGroups')
              .filter(userGroup => {
                return userGroup.name != 'Management'
                        && userGroup.name != 'Cashier'
              });
    },
    roles() {
      return this
              .getArray('roles')
              .filter(role => {
                return role.name == 'Order taker / Staff / Waitress'
                        || role.name == 'Other Staff'
              });
    },
    location() {
      return this.getMap('user', true).location;
    },
  },
  methods: {
    async onSubmit(e) {
      this.submitted = true;
      const valid = await this.$validator.validate();
      if (valid) {
        const response = await StaffService.add(this.obj);
        if(response.error) {
          if(Array.isArray(response.error)) {
            response.error.forEach(err => {
              this.errors.add({
                field: err.field,
                msg: err.error,
              });
            })
          }
        } else {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Staff added successfully'));
          this.submitted = false;
          this.obj = {
            subRoles: [],
            userGroup: null,
            location: null,
            subLocations: []
          };
        }
      }
    },
  },
  mounted() {
    if(!this.obj.userGroup && this.defaultUserGroup) {
      this.obj.userGroup = this.defaultUserGroup.id;
    }
    this.obj.subLocations = [this.location.id];
  },
  watch: {
    userGroups() {
      if(!this.obj.userGroup && this.defaultUserGroup) {
        this.obj.userGroup = this.defaultUserGroup.id;
      }
    }
  }
};
</script>
